import { Link } from 'react-router-dom';

import { DataTable, type Column } from '../components/DataTable.tsx';
import { Pagination } from '../components/Pagination.tsx';
import { money } from '../lib/format.ts';
import { usePaginatedList } from '../lib/usePaginatedList.ts';

interface CustomerRow {
  id: number;
  customerNo: string;
  name: string;
  currency: string;
  country: string | null;
  salesman: string | null;
  balance: number;
  termText: string | null;
}

export function CustomersListPage() {
  const list = usePaginatedList<CustomerRow>({
    endpoint: '/api/dashboard/customers',
    defaultSortColumn: 'name',
    defaultSortDirection: 'ASC',
  });

  const columns: Column<CustomerRow>[] = [
    {
      key: 'customer_no',
      label: 'Code',
      sortable: true,
      className: 'mono',
      render: (r) => (
        <Link to={`/customers/${encodeURIComponent(r.customerNo)}`}>{r.customerNo}</Link>
      ),
    },
    { key: 'name', label: 'Name', sortable: true, render: (r) => r.name },
    { key: 'salesman', label: 'Salesman', sortable: true, render: (r) => r.salesman ?? '—' },
    {
      key: 'balance',
      label: 'Balance',
      sortable: true,
      className: 'num',
      render: (r) => money(r.balance, r.currency),
    },
  ];

  return (
    <>
      <header className="main-header">
        <h1 className="main-title">Customers</h1>
        <span className="main-subtitle">{list.data ? `${list.data.total} total` : ''}</span>
      </header>

      <div className="toolbar">
        <input
          placeholder="Search code or name…"
          defaultValue={list.state.search}
          onChange={(e) => list.setSearch(e.target.value)}
        />
      </div>

      {list.error && <div className="error">{(list.error as Error).message}</div>}
      {list.isLoading && !list.data && <div className="loading">Loading…</div>}

      {list.data && (
        <>
          <DataTable
            columns={columns}
            rows={list.data.rows}
            rowKey={(r) => r.id}
            sortColumn={list.state.sortColumn}
            sortDirection={list.state.sortDirection}
            onSortChange={list.toggleSort}
          />
          <Pagination
            page={list.state.page}
            pageSize={list.state.pageSize}
            total={list.data.total}
            onPageChange={list.setPage}
          />
        </>
      )}
    </>
  );
}
